import TieupLogo from "src/components/common/TieupLogo"
import { useRouter } from "next/router"
import React, { useCallback } from "react"
import { confirmAlert } from "react-confirm-alert"
import { useLocalStorage } from "react-use"
import routes from "routes"
import URLUtils from "src/utils/URLUtils"

const useNotAuthNotification = () => {
  const router = useRouter()

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [redirectPage, setRedirectPage] = useLocalStorage<string>(
    "redirect_page",
    "",
  )

  /** リダイレクト先のページを保存 */
  const setPage = useCallback(() => {
    const path = window.location.pathname
    setRedirectPage(path)
  }, [setRedirectPage])

  const notAuthNotification = useCallback(() => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <>
            <div className="p-modal modal-primary js-modal">
              <div className="p-modal-inner">
                <div className="p-modal-contents">
                  <div className="p-modal-contents-inner">
                    <button
                      className="c-close-button p-modal-close js-modal-close"
                      onClick={onClose}
                    >
                      <span className="c-close-button-icon"></span>
                      <span className="c-close-button-label">閉じる</span>
                    </button>
                    <div className="modal-primary-body">
                      <div className="modal-primary-body-inner">
                        <div
                          style={{
                            width: "240px",
                            margin: "auto",
                            marginBottom: "20px",
                          }}
                        >
                          <TieupLogo />
                        </div>
                        <div style={{ textAlign: "center" }}>
                          <p style={{ fontSize: "14px" }}>
                            たいあっぷはイラスト・小説コラボ型投稿サイトです。
                          </p>
                          <p style={{ fontSize: "13px" }}>
                            ユーザー向け機能を利用するには、
                            <br />
                            <a
                              href={URLUtils.getHelpPage("terms/index.html")}
                              target="_blank"
                              rel="noreferrer"
                            >
                              利用規約
                            </a>
                            、
                            <a
                              href="https://www.trenders.co.jp/privacy/"
                              target="_blank"
                              rel="noreferrer"
                            >
                              プライバシーポリシー
                            </a>
                            に同意したうえでログインしてください。
                          </p>
                          <div style={{ marginTop: "25px" }}>
                            <button
                              className="global-header-login-button-notAuth"
                              onClick={() => {
                                onClose()
                                setPage()
                                router.push(routes.authSignIn())
                              }}
                            >
                              ログイン
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="p-modal-overlay js-modal-overlay"></div>
          </>
        )
      },
    })
  }, [router, setPage])

  return { notAuthNotification }
}

export { useNotAuthNotification }
